import { LegacyOriginIcon, LegacyFinishIcon } from './legacy-icons';

/**
 * The route cell (`tableHeaderSelector.tsx:228-285`): EVERY pickup address
 * first, then EVERY drop-off address, each on its own line with the origin
 * dot / finish flag. Text WRAPS (`whiteSpace: pre-line` in the source) rather
 * than truncating — the old grid's rows were `autoHeight`, so a long address
 * grew the row instead of clipping. The 70px row height is a MINIMUM.
 */
export function LegacyRouteCell({
  origin,
  destination,
}: {
  origin: string[];
  destination: string[];
}) {
  const stops = [
    ...origin.map((name) => ({ name, type: 'origin' as const })),
    ...destination.map((name) => ({ name, type: 'destination' as const })),
  ];

  return (
    <div className="flex min-w-0 flex-1 flex-col justify-center gap-2 py-2">
      {stops.map((stop, index) => (
        <span
          // Addresses can repeat; the position within the leg list IS the identity.
          key={`${stop.type}-${index}`}
          className="flex items-center gap-2 text-[16px] font-medium text-[var(--lg-grey-600)]"
        >
          {stop.type === 'origin' ? (
            <LegacyOriginIcon className="shrink-0 text-[var(--lg-fg)]" />
          ) : (
            <LegacyFinishIcon className="shrink-0 text-[var(--lg-fg)]" />
          )}
          <span className="min-w-0 whitespace-pre-line">{stop.name}</span>
        </span>
      ))}
    </div>
  );
}
